import * as maplibregl from "maplibre-gl";
import workerUrl from "maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url";
import "maplibre-gl/dist/maplibre-gl.css";
import { Protocol } from "pmtiles";

// Registratie van het pmtiles-protocol, nodig voor elke kaart die de
// perceel-tileset laadt. Importeer deze module in zo'n kaart in plaats van te
// vertrouwen op het side effect van een andere component.
const protocol = new Protocol();
maplibregl.addProtocol("pmtiles", protocol.tile);
maplibregl.setWorkerUrl(workerUrl);

// Gebouwd met tippecanoe ≥ 2.55: eerdere tilesets droegen door een hash-botsing
// in de string pool bij ~0,5% van de percelen het id van een ander perceel
// (bodematlas/ca_reference#13). Controleer een nieuwe tileset op
// 6.567208,53.138919: daar hoort `EDE02 D 4909` te staan.
export const PARCEL_TILES = "pmtiles://https://ref.cadamap.com/tiles/combined_20260920.pmtiles";
// De tileset heeft twee lagen: `default` met de perceelvlakken (id = naam, zoals
// "GST00 I 1") en `label` met daarnaast `short_name`.
export const PARCEL_SOURCE_LAYER = "default";
